import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const savedLanguage = localStorage.getItem("language") || "en"; //  Load from localStorage

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations: {
          Add: "Add",
          Update: "Update",
        },
      },
      hn: {
        translations: {
          Home: "होम",
          Dashboard: "डैशबोर्ड",
          "Feedback Form": "प्रतिपुष्टी फ़ार्म",
          Name: "नाम",
          "Enter name": "नाम दर्ज करें",
          "Name is required": "नाम आवश्यक है",
          "Only Hindi and English alphabets, spaces, '.' and '/' are allowed":
            "केवल हिंदी और अंग्रेजी अक्षर, रिक्त स्थान, '.' और '/' की अनुमति है",
          "name must be at least 2 characters long":
            "नाम कम से कम 2 अक्षर लंबा होना चाहिए",
          "name cannot exceed 50 characters":
            "नाम 50 अक्षरों से अधिक नहीं हो सकता",
          "Mobile Number": "मोबाइल नंबर",
          "Enter Mobile number": "मोबाइल नंबर दर्ज करें",
          "Mobile number is required": "मोबाइल नंबर आवश्यक है",
          "Enter a valid 10-digit Indian mobile number starting with 6-9":
            "6-9 से शुरू होने वाला वैध 10 अंकों का भारतीय मोबाइल नंबर दर्ज करें",
          "Enter Email Address": "ईमेल पता दर्ज करें",
          "Email address required": "ईमेल पता आवश्यक है",
          "Enter valid email address": "वैध ईमेल पता दर्ज करें",
          Address: "पता दर्ज करें",
          "Address is required": "पता आवश्यक है",
          "Only Hindi, English alphanumeric characters, and [ , . / - _ ( )] are allowed":
            "केवल हिंदी, अंग्रेजी अक्षरांकीय वर्ण, और [ , . / - _ ( )] अनुमति दी जाती है",
          "Suggestions | Inquiries": "सुझाव | पूछताछ",
          "Enter Suggestions": "सुझाव दर्ज करें",
          "Suggestions | Inquiries is required": "सुझाव | पूछताछ आवश्यक है",
          "Captcha is required": "कैप्चा आवश्यक है",
          "Enter CAPTCHA": "कैप्चा दर्ज करें",
          Save: "सहेजें",
          "Invalid Captcha": "अमान्य कैप्चा",
          "Preview & Save": "पूर्वावलोकन करें और सहेजें",
          "Visitors Count": "आगंतुकों की संख्या",
          "READ MORE": "और पढ़ें",
          "ABOUT US": "हमारे बारे में",
          "Foundation Globally": "वैश्विक स्तर पर फाउंडेशन",
          "The open schooling system was established in XXXX in the state to provide flexible education to diverse learners. It evolved from the National Open School (NOS), aiming to address the educational needs of those unable to access traditional schooling.":
            "राज्य में मुक्त विद्यालयी शिक्षा प्रणाली की स्थापना की गई विविध शिक्षार्थियों को लचीली शिक्षा प्रदान करें। से इसका विकास हुआ नेशनल ओपन स्कूल (एनओएस), जिसका लक्ष्य शैक्षिक आवश्यकताओं को पूरा करना है जो पारंपरिक स्कूली शिक्षा प्राप्त करने में असमर्थ हैं।",
          "INFORMATION ABOUT": "जानकारी",
          "IMPORTANT WEBSITES": "महत्वपूर्ण वेबसाइटें",
          Admission: "प्रवेश",
          "Online Course Material": "ऑनलाइन पाठ्यक्रम सामग्री",
          "Examination and Results": "परीक्षा एवं परिणाम",
          "Study Center": "अध्ययन केंद्र",
          Examination: "परीक्षा",
          "E-Services": "ई-सेवाएँ",
          "Notice Board": "सूचना पट्ट",
          "Success Stories": "सफलता की कहानियाँ",
          Library: "पुस्तकालय",
          Office: "कार्यालय",
          "Take the open school quiz and test your Open something.":
            "ओपन स्कूल क्विज़ लें और अपना ओपन कुछ परीक्षण करें।",
          "IMPORTANT LINKS": "महत्वपूर्ण लिंक",
          March: "मार्च",
          Announcement: "घोषणा",
          "Events & Announcement": "घटनाएँ एवं घोषणाएँ",
          "The open schooling system was established in XXXX in the state to provide flexible education to diverse learners. It evolved from the National Open School (NOS), aiming to address.":
            "राज्य में विविध शिक्षार्थियों को लचीली शिक्षा प्रदान करने के लिए XXXX में ओपन स्कूलिंग प्रणाली स्थापित की गई थी। यह नेशनल ओपन स्कूल (NOS) से विकसित हुआ, जिसका उद्देश्य आवश्यकताओं को पूरा करना था।",
          "New registration is open for class 10th in the session 2024-25":
            "सत्र 2024-25 के लिए कक्षा 10वीं के नए पंजीकरण खुले हैं।",
          "The result is announced for supplementary examination held in October November 2003":
            "अक्टूबर-नवंबर 2003 में आयोजित पूरक परीक्षा का परिणाम घोषित कर दिया गया है।",
          "Meeting & Events": "बैठक और कार्यक्रम",
          "R.T.I": "सूचना का अधिकार (आर.टी.आई)",
          "Download Section": "डाउनलोड अनुभाग",
          Report: "रिपोर्ट",
          "Audio Gallery": "ऑडियो गैलरी",
          "Proud Learners": "गौरवान्वित शिक्षार्थी",
          "Uttar Pradesh State Open School Board (UPSOSB)":
            "उत्तर प्रदेश राज्य मुक्त विद्यालय बोर्ड (UPSOSB)",
          "The Uttar Pradesh State Open School Board (UPSOSB) is an autonomous board running under the auspices of Open Schooling of Uttar Pradesh Government’s Education Department":
            "उत्तर प्रदेश राज्य मुक्त विद्यालय बोर्ड (UPSOSB) उत्तर प्रदेश सरकार के शिक्षा विभाग के ओपन स्कूलिंग के तत्वावधान में संचालित एक स्वायत्त बोर्ड है।",
          "Admin Login": "एडमिन लॉगिन",
          "Web Information Manager": "वेब सूचना प्रबंधक",
          Archives: "संग्रह",
          FAQs: "अक्सर पूछे जाने वाले प्रश्न",
          Feedback: "प्रतिक्रिया",
          "Contact Us": "हमसे संपर्क करें",
          "Help Desk": "सहायता डेस्क",
          "Site Security": "साइट सुरक्षा",
          "Employee Corner": "कर्मचारी कॉर्नर",
          RTI: "आरटीआई",
          "Terms and Conditions": "नियम और शर्तें",
          "Hyper Linking Policy": "हाइपर लिंकिंग नीति",
          "Privacy Policy": "गोपनीयता नीति",
          "Copyright Policy": "कॉपीराइट नीति",
          "Anuj Dixit": "अनुज दीक्षित",
          "AD - D&P": "एडी - डी एंड पी",
          Phone: "फ़ोन",
          Email: "ईमेल",
          "Testing Centers": "परीक्षण केंद्र",
          "Blood Banks": "रक्त बैंक",
          "Suraksha Clinics": "सुरक्षा क्लिनिक",
          "ART Centers": "एआरटी केंद्र",
          "UPSACS MIS": "यूपीएसएसीएस एमआईएस",
          "Quick Links": "त्वरित लिंक",
          "Connect with us": "हमसे संपर्क करें",
          "Important Links": "महत्वपूर्ण लिंक्स",
          "Reach Us": "हमसे संपर्क करें",
          Designation: "पदनाम",
          Guidelines: "दिशानिर्देश",
          address:
            "7वीं मंजिल, मंडी परिषद भवन, 16 एपी सेन रोड, लखनऊ-226001, उत्तर प्रदेश, भारत।",
          "Last Updated": "अंतिम अद्यतन",
          copyrightYear: "कॉपीराइट वर्ष",
          poweredBy: "संचालित",
          "Welcome to the Uttar Pradesh State Open School Board (UPSOSB), an initiative by the Government of Uttar Pradesh established under the UPSOSB Act, 2008 (Act No. 27). The Board provides quality open and distance education to learners unable to attend formal schools due to social, economic, or personal reasons.":
            "उत्तर प्रदेश राज्य मुक्त विद्यालय परिषद (UPSOSB) की स्थापना उत्तर प्रदेश सरकार द्वारा वर्ष 2008 में अधिनियम संख्या 27 के तहत की गई। यह परिषद उन विद्यार्थियों को गुणवत्तापूर्ण मुक्त एवं दूरस्थ शिक्षा प्रदान करती है जो सामाजिक, आर्थिक या व्यक्तिगत कारणों से औपचारिक विद्यालय नहीं जा सके।",
          "7th Floor, Mandi Parishad Bhavan, 16 AP Sen Road, Lucknow-226001, Uttar Pradesh, India.":
            "7वीं मंजिल, मंडी परिषद भवन, 16 एपी सेन रोड, लखनऊ-226001, उत्तर प्रदेश, भारत।",
          "Govt. Toll Free No.": "सरकारी टोल फ्री नंबर",
          Search: "खोज",
          Newsletter: "न्यूज़लैटर",
          Sitemap: "साइटमैप",
          "Site Map": "साइट मानचित्र",
          FAQ: "एफ ए क्यू",
          Gallery: "गैलरी",
          Testimonial: "प्रशंसापत्र",
          Hindi: "हिंदी",
          English: "अंग्रेजी",
          "All rights reserved.": "सभी अधिकार सुरक्षित।",
          Copyright: "कॉपीराइट ",
          "Powered By": "द्वारा संचालित",
          "Meeting & Events": "रियूनियन्स एट इवेंमेंट्स",
          "R.T.I": "आर.टी.आई",
          "Download Section": "टेलीचार्जमेंट अनुभाग",
          Reports: "रिपोर्ट्स",
          "Audio Gallery": "गैलरी ऑडियो",
          "Proud Learners": "प्रशिक्षु फ़ायर",
          "Need any help?": "किसी मदद की ज़रूरत?",
          "Here you can get your perfect answer for your problem.":
            "यहां आप अपनी समस्या का सही उत्तर पा सकते हैं।",
          "Contact Now": "अभी संपर्क करें",
          "Serial no.": "सीरीयल नम्बर",
          "Uploading Date": "अपलोड करने की तारीखें",
          Description: "विवरण",
          Download: "डाउनलोड करना",
          News: "समाचार",
          Format: "प्रारूप",
          Date: "दिनांक",
          Language: "भाषा",
          Size: "आकार",
          "No content available": "कोई सामग्री उपलब्ध नहीं है",
          "Uttar Pradesh State Open School": "उत्तर प्रदेश स्टेट ओपन स्कूल",
          "Video Gallery": "वीडियो गैलरी",
          "INFORMATION ABOUT": "बारे में जानकारी",
          "WHAT'S NEW": "नया क्या है",
          "Click here to download": "इसे डाउनलोड करने यहाँ क्लिक करें",
          "Archive From": "पुरालेख से",
          Archive: "पुरालेख",
          "You are being redirected to an external website. Please note that upsosb is not responsible for the content and privacy policies of external websites and go to:":
            "आपको एक बाहरी वेबसाइट पर पुनः निर्देशित किया जा रहा है। कृपया ध्यान दें कि upsosb बाहरी वेबसाइटों की सामग्री और गोपनीयता नीतियों के लिए ज़िम्मेदार नहीं है और यहाँ जाएँ:",
          "Do you want to continue?": "क्या आप जारी रखना चाहते हैं?",
          "Welcome to the Uttar Pradesh State Open School Board (UPSOSB), an initiative by the Government of Uttar Pradesh established under the Uttar Pradesh State Open School Board Act, 2008 (Act No. 27 of 2008). The UPSOSB is dedicated to providing quality open and distance education at school level to those who are unable to pursue formal schooling due to various reasons, including  social, economic, geographical, or personal constraints.":
            "राज्य मुक्त विद्यालय परिषद, मुक्त एवं दूरस्थ विद्यालयी शिक्षा को बढ़ावा देने हेतु प्रदेश सरकार के द्वारा संचालित कार्यक्रम है, जिसे उत्तर प्रदेश राज्य मुक्त विद्यालय परिषद अधिनियम, 2008 (अधिनियम संख्या 27, 2008) के तहत स्थापित किया गया है। जिसके तहत ऐसे सभी व्यक्तियों के लिए विद्यालय स्तर पर दूरस्थ शिक्षा की व्यवस्था की जाएगी, जो किसी भी विद्यालय में अपना प्रवेश नहीं ले सकते हैं । ",
          Image: "छवि",
          "Image 1": "छवि 1",
          "Image 2": "छवि 2",
          "Image 3": "छवि 3",
          "Image 4": "छवि 4",
          "Image 5": "छवि 5",
          "Image 6": "छवि 6",
          "Image 7": "छवि 7",
          "Image 8": "छवि 8",
          "Image 9": "छवि 9",
          "Event and Announcement": "घटनाएँ और घोषणाएँ",
          "You are about to change the language of the site to":
            "आप साइट की भाषा बदलने जा रहे हैं",
          "Do you want to continue?": "क्या आप जारी रखना चाहते हैं?",
          "Our Dignitaries": "हमारे गणमान्य व्यक्ति",
          "Yogi Adityanath": "योगी आदित्यनाथ",
          "Hon’ble Chief Minister,Uttar Pradesh":
            "माननीय मुख्यमंत्री, उत्तर प्रदेश",
          "Smt. Gulab Devi": "श्रीमती गुलाब देवी",
          "Hon’ble Minister of State, Secondary Education":
            "माननीय राज्य मंत्री, माध्यमिक शिक्षा",
          "Shri Deepak Kumar, IAS": "श्री दीपक कुमार, आईएएस",
          "Additional Chief Secretary, Secondary Education":
            "अपर मुख्य सचिव, माध्यमिक शिक्षा",
          "Shri Mahendra Dev": "श्री महेंद्र देव",
          "Chairperson, Uttar Pradesh State Open School Board":
            "अध्यक्ष, उत्तर प्रदेश राज्य मुक्त विद्यालय बोर्ड",
          "Shri Ajay Kumar Dwivedi": "श्री अजय कुमार द्विवेदी",
          "Director, Uttar Pradesh State Open School Board":
            "निदेशक, उत्तर प्रदेश राज्य मुक्त विद्यालय बोर्ड",
          "Management Directory": "प्रबंधन निर्देशिका",
          "E-mail": "ई-मेल",
          "Please select at least one option": "कृपया कम से कम एक विकल्प चुनें",
          "DOB field is required": "DOB फ़ील्ड आवश्यक है",
          "This field is required": "यह फ़ील्ड आवश्यक है",
          "Please select any option": "कृपया कोई भी विकल्प चुनें",
          "Please select an option": "कृपया एक विकल्प चुनें",
          "District:": "ज़िला",
          "Block:": "ब्लॉक",
          "Nodal Center Name": "नोडल केंद्र का नाम",
          "Nodal Center Code": "नोडल केंद्र कोड",
          "53,Mahatma Gandhi marg, Prayagraj, UP.":
            "53, महात्मा गांधी मार्ग, प्रयागराज, उ.प्र.",
          "Personal Details": "व्यक्तिगत विवरण",
          "Subjects Selection": "विषय चयन",
          "Upload Documents": "दस्तावेज़ अपलोड करें",
          "Review:": "समीक्षा",
          "Payment:": "भुगतान",
          "Nodal Center Information": "नोडल केंद्र की जानकारी",
          "Photo Uploaded": "फोटो अपलोड किया गया",
          "Signature Uploaded": "हस्ताक्षर अपलोड किया गया",
          "Basic Information": "मूल जानकारी",
          "Secondary (10th)": "माध्यमिक (10वीं)",
          "Sr. Secondary (12th)": "सीनियर सेकेंडरी (12वीं)",
          Session: "सत्र",
          Stream: "धारा",
          "First Name": "पहला नाम",
          "Middle Name": "मध्य नाम",
          "Last Name ": "आखरी नाम",
          "Applicant’s Aadhaar Number": "आवेदक का आधार नंबर",
          "Father Name": "पिता का नाम",
          "Mother Name": "माँ का नाम",
          "Date of Birth": "जन्म तिथि",
          "Age on Date": "दिनांक पर आयु",
          Gender: "लिंग",
          Nationality: "राष्ट्रीयता",
          Religion: "धर्म",
          "Social Category": "सामाजिक श्रेणी",
          "Rural/Urban": "शहरी ग्रामीण",
          "Disadvantage Group": "वंचित समूह",
          Disability: "विकलांगता",
          "Medium of Study": "अध्ययन का माध्यम",
          "Current Address": "वर्त्तमान पता",
          "House No./ Flat No.": "मकान नं./फ्लैट नं.",
          "Village/Town": "गांव शहर",
          State: "राज्य",
          "Gram Panchayat": "ग्राम पंचायत",
          Pincode: "पिनकोड",
          "Telephone/Mobile": "टेलीफोन/मोबाइल",
          "Last Educational Qualification of Applicant":
            "आवेदक की अंतिम शैक्षणिक योग्यता",
          "Year of Passing": "पारित होने का वर्ष",
          "Board Name": "बोर्ड का नाम",
          "Permanent Address": "स्थायी पता",
          "Same as Above": "ऊपर की तरह",
          "Bank Details": "बैंक विवरण",
          "Bank Account Holder Name": "बैंक खाताधारक का नाम",
          "Account No.": "खाता नंबर",
          "Confirm Account No": "खाता संख्या की पुष्टि करें",
          "Bank Name": "बैंक का नाम",
          "Branch Name": "शाखा का नाम",
          "IFSC Code": "आईएफएससी कोड",
          Next: "अगला",
          Urban: "शहरी",
          Rural: "ग्रामीण",
          Yes: "हाँ",
          No: "नहीं",
          "Not Applicable": "लागू नहीं",
          "Note- Student can select Maximum (Seven) Subjects & (One) language Subject is Mandatory":
            "नोट- विद्यार्थी अधिकतम (सात) विषय और (एक) भाषा विषय का चयन कर सकता है, विषय अनिवार्य है",
          "Subject*": "विषय*",
          "S.NO": "क्र.सं",
          Back: "पीछे",
          "List of Attached Documents *": "संलग्न दस्तावेजों की सूची *",
          "Applying for TOC/Part Exam: Yes/No":
            "TOC/आंशिक परीक्षा के लिए आवेदन: हाँ/नहीं",
          Class: "कक्षा",
          "Year of Attempt": "प्रयास का वर्ष",
          "Roll No.": "रोल नं.",
          "Theory Marks *": "सिद्धांत अंक *",
          "Practical Marks *": "प्रैक्टिकल अंक *",
          "Total Marks Obtained*": "कुल प्राप्त अंक*",
          "Grade *": "श्रेणी *",
          "IT IS MANDATORY FOR THE APPLICANT TO GIVE THE FOLLOWING DECLARATION TO APPEAR IN THE STATE OPEN SCHOOL EXAM":
            "राज्य मुक्त विद्यालय परीक्षा में सम्मिलित होने के लिए आवेदक को निम्नलिखित घोषणा पत्र देना अनिवार्य है",
          Place: "जगह",
          "Signature of Applicant *": "आवेदक के हस्ताक्षर *",
          "Students can transfer their grades from a prior recognized board to ABC State Open School using the Transfer of Credit (TOC) option. Students who have not passed or have received low grades in certain subjects can apply for TOC.":
            "छात्र क्रेडिट ट्रांसफर (TOC) विकल्प का उपयोग करके अपने ग्रेड को किसी पूर्व मान्यता प्राप्त बोर्ड से ABC स्टेट ओपन स्कूल में स्थानांतरित कर सकते हैं। जो छात्र कुछ विषयों में उत्तीर्ण नहीं हुए हैं या जिन्हें कम ग्रेड मिले हैं, वे TOC के लिए आवेदन कर सकते हैं।",
          "Note:": "टिप्पणी:",
          "Signature of Applicant": "आवेदक के हस्ताक्षर",
          "I hereby declare that the personal information provided is true, accurate, and complete to the best of my knowledge. I understand that any false or misleading information may result in disqualification or withdrawal of my registration. The documents uploaded as part of this registration are genuine and belong to me. I authorize":
            "मैं इस प्रकार घोषणा करता हूँ कि प्रदान की गई व्यक्तिगत जानकारी मेरे सर्वोत्तम ज्ञान के अनुसार सत्य, सटीक और पूर्ण है। मैं समझता हूँ कि किसी भी गलत या भ्रामक जानकारी के परिणामस्वरूप मेरा पंजीकरण अयोग्य ठहराया जा सकता है या वापस लिया जा सकता है। इस पंजीकरण के भाग के रूप में अपलोड किए गए दस्तावेज़ वास्तविक हैं और मेरे हैं। मैं अधिकृत करता हूँ",
          "I hereby declare that the personal information provided is true, accurate, and complete to the best of my knowledge. I understand that any false or misleading information may result in disqualification or withdrawal of my registration. The documents uploaded as part of this registration are genuine and belong to me. I authorize":
            "मैं इस प्रकार घोषणा करता हूँ कि प्रदान की गई व्यक्तिगत जानकारी मेरे सर्वोत्तम ज्ञान के अनुसार सत्य, सटीक और पूर्ण है। मैं समझता हूँ कि कोई भी गलत या भ्रामक जानकारी मेरे पंजीकरण को अयोग्य या वापस लेने का कारण बन सकती है। इस पंजीकरण के भाग के रूप में अपलोड किए गए दस्तावेज़ वास्तविक हैं और मेरे हैं। मैं अधिकृत करता हूँ",
          Submit: "जमा करना",
          "Select here...": "यहाँ चयन करें...",
          "Type Here...": "यहाँ लिखें...",
          "Upload Photo": "फ़ोटो अपलोड करें",
          "Photo Uploaded": "फ़ोटो अपलोड हो गया",
          "Upload Signature": "हस्ताक्षर अपलोड करें",
          "Signature Uploaded": "हस्ताक्षर अपलोड हो गया",
          Upload: "अपलोड",
          "Image is required": "छवि आवश्यक है",
          "SAVE & CONTINUE": "सहेजें जारी रखें",
          "Auto Generated": "स्वतः जनित",
          "Click here to Select Education Boards":
            "शिक्षा बोर्ड चुनने के लिए यहां क्लिक करें",
          "Enter IFSC Code": "IFSC कोड दर्ज करें",
          "Enter Pincode": "पिनकोड दर्ज करें",
          "Enter House/Flat Number": "घर/फ्लैट नंबर दर्ज करें",
          "Enter Pincode": "पिनकोड दर्ज करें",
          "Enter Bank Account Holder Name": "बैंक खाता धारक का नाम दर्ज करें",
          "Enter First Name": "प्रथम नाम दर्ज करें",
          "Enter Middle Name": "मध्य नाम दर्ज करें",
          "Enter Last Name": "अंतिम नाम दर्ज करो",
          "Enter Aadhaar Number": "आधार नंबर दर्ज करें",
          "Enter Father Name": "पिता का नाम दर्ज करें",
          "Enter Mother Name": "माता का नाम दर्ज करें",
          "Enter Village/Town Number": "गांव/कस्बा नंबर दर्ज करें",
          "Enter Email": "ईमेल दर्ज करें",
          "Enter Telephone/Mobile Number": "टेलीफोन/मोबाइल नंबर दर्ज करें",
          "Enter Year of Passing": "उत्तीर्ण वर्ष दर्ज करें",
          "Enter Account No.": "खाता संख्या दर्ज करें.",
          "Enter Confirm Account Number": "पुष्टि खाता संख्या दर्ज करें",
          "Enter Bank Name": "बैंक का नाम दर्ज करें",
          "Enter Branch Name": "शाखा का नाम दर्ज करें",
          "Nodal Center Information": "नोडल केंद्र की जानकारी",
          District: "जिला",
          Block: "ब्लॉक",
          "Nodal Center Name": "नोडल केंद्र का नाम",
          "Nodal Center Code": "नोडल केंद्र कोड",
          "Basic Details": "मूल विवरण",
          "General Admission": "सामान्य प्रवेश",
          Class: "कक्षा",
          "Enter Year of Passing": "उत्तीर्ण वर्ष दर्ज करें",
          "Enter Account No.": "खाता संख्या दर्ज करें.",
          "Enter Confirm Account Number": "पुष्टि खाता संख्या दर्ज करें",
          "Enter Bank Name": "बैंक का नाम दर्ज करें",
          "Enter Branch Name": "शाखा का नाम दर्ज करें",
          "This Field is required": "यह फ़ील्ड आवश्यक है",
          "This Field is required": "यह फ़ील्ड आवश्यक है",
          "Session:": "सत्र:",
          "Stream:": "स्ट्रीम:",
          "First Name:": "पहला नाम:",
          "Last Name:": "अंतिम नाम:",
          "Applicant’s Aadhaar No.:": "आवेदक का आधार संख्या:",
          "Father Name:": "पिता का नाम:",
          "Mother Name:": "माता का नाम:",
          "Date of Birth:": "जन्म तिथि:",
          "Age on Date:": "तिथि पर आयु:",
          "Gender:": "लिंग:",
          "Nationality:": "राष्ट्रीयता:",
          "Religion:": "धर्म:",
          "Social Category:": "सामाजिक वर्ग:",
          "Rural/Urban:": "ग्रामीण/शहरी:",
          "Disadvantage Group:": "वंचित समूह:",
          "Disability:": "विकलांगता:",
          "Medium of Study:": "अध्ययन का माध्यम:",
          "Current Address": "वर्तमान पता",
          "House No./ Flat No.:": "मकान नंबर / फ्लैट नंबर:",
          "Village/ Town:": "गांव / शहर:",
          "State:": "राज्य:",
          "District:": "जिला:",
          "Block:": "ब्लॉक:",
          "Gram Panchayat:": "ग्राम पंचायत:",
          "Pincode:": "पिनकोड:",
          "E-mail:": "ई-मेल:",
          "Telephone/ Mobile:": "टेलीफोन/मोबाइल:",
          "Last Educational Qualification:": "अंतिम शैक्षणिक योग्यता:",
          "Year of Passing:": "उत्तीर्ण वर्ष:",
          "Board Name:": "बोर्ड का नाम:",
          "Permanent Address": "स्थायी पता",
          "Same as Above": "उपरोक्त के समान",
          "Bank Details": "बैंक विवरण",
          "Account Holder Name": "खाता धारक का नाम",
          "Account No.": "खाता संख्या:",
          "Confirm Account No.": "खाता संख्या की पुष्टि करें",
          "Bank Name": "बैंक का नाम",
          "Branch Name": "शाखा का नाम",
          "IFSC Code": "आईएफएससी कोड",
          "Edit Step 1": "चरण 1 संपादित करें",
          "Choose Subjects": "विषय चुनें",
          Subject: "विषय",
          "Edit Step 2": "चरण 2 संपादित करें",
          Payment: "भुगतान",
          Review: "समीक्षा",
          "List of Attached Documents": "संलग्न दस्तावेज़ों की सूची",
          Document: "दस्तावेज़",
          "Edit Step 3": "चरण 3 संपादित करें",
          "I hereby declare that the personal information provided is true, accurate, and complete to the best of my knowledge. I understand that any false or misleading information may result in disqualification or withdrawal of my registration. The documents uploaded as part of this registration are genuine and belong to me. I authorize [ABC state open school] to verify the authenticity of the information and documents provided. I consent to the use of my personal information for registration, academic administration, and communication purposes, and acknowledge that my data will be stored securely in accordance with the [ABC state open school] privacy policy. I agree to comply with all the rules and regulations of [ABC state open school] and understand that non-compliance may result in disciplinary action.":
            "मैं यहां घोषणा करता/करती हूं कि दी गई व्यक्तिगत जानकारी मेरी जानकारी के अनुसार सत्य, सटीक और पूर्ण है। मैं समझता/समझती हूं कि कोई भी झूठी या भ्रामक जानकारी मेरी पंजीकरण की अयोग्यता या वापसी का कारण बन सकती है। इस पंजीकरण के हिस्से के रूप में अपलोड किए गए दस्तावेज़ असली हैं और मेरे ही हैं। मैं [ABC राज्य मुक्त विद्यालय] को दी गई जानकारी और दस्तावेज़ों की प्रामाणिकता की पुष्टि करने की अनुमति देता/देती हूं। मैं पंजीकरण, शैक्षणिक प्रशासन और संचार उद्देश्यों के लिए मेरी व्यक्तिगत जानकारी के उपयोग के लिए सहमति देता/देती हूं, और स्वीकार करता/करती हूं कि मेरा डेटा [ABC राज्य मुक्त विद्यालय] की गोपनीयता नीति के अनुसार सुरक्षित रूप से संग्रहीत किया जाएगा। मैं [ABC राज्य मुक्त विद्यालय] के सभी नियमों और विनियमों का पालन करने के लिए सहमत हूं और समझता/समझती हूं कि गैर-अनुपालन से अनुशासनात्मक कार्रवाई हो सकती है।",

          "Uttar Pradesh State Open School Board (UPSOSB) is an autonomous institution functioning under the Directorate of Secondary Education, Government of Uttar Pradesh.":
          "उत्तर प्रदेश राज्य मुक्त विद्यालय परिषद (UPSOSB) उत्तर प्रदेश सरकार के माध्यमिक शिक्षा निदेशालय के अधीन कार्यरत एक स्वायत्त संस्था है।"

        },
      },
    },
    lng: savedLanguage, //  Set initial language
    fallbackLng: "en",
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });
export default i18next;
